<template>
  <navbar position="fixed" type="primary" menu-classes="ml-auto">
    <template slot-scope="{ toggle, isToggled }"> 
      <nav-link to="/">
        
        Home
      </nav-link>            
        <li class="nav-item">
          <router-link class="nav-link" to="/"> 
            Home
          </router-link>       
        </li>
      <router-link class="navbar-item" to="/">
        My Site Name
      </router-link>      
      <router-link class="navbar-brand" to="/">
        My Site Name
      </router-link>      
      <router-link class="navbar-brand" to="/">
        My Site Name
      </router-link>      
    </template>
    <template slot="navbar-menu">
      <drop-down tag="li" title="Sample Dropdown">
        <nav-link class="dropdown-item">
          <i class="now-ui-icons shopping_box"></i> Headers
        </nav-link>
      </drop-down>
    </template>
  </navbar>
</template>

<script>
import { DropDown, NavbarToggleButton, Navbar, NavLink } from '@/components';

export default {
  name: 'main-navbar',
  components: {
    DropDown,
    Navbar,
    NavbarToggleButton,
    NavLink
  }
};
</script>

<style scoped></style>
